// extracted by mini-css-extract-plugin
export default {"evidenceListContainer":"EvidenceTextList_evidenceListContainer__SMKOi","evidenceListCard":"EvidenceTextList_evidenceListCard__dHFZ8"};